/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
var e=(...e)=>window.posthog?.capture(...e),t=()=>Array.from(Array(20),()=>Math.floor(Math.random()*36).toString(36)).join(``),n=()=>{let e=window.localStorage.getItem(`ph_initial_id`)??t();return window.localStorage.setItem(`ph_initial_id`,e),e},r=()=>window.localStorage.getItem(`ph_distinct_id`)??void 0;export{n as getPosthogAnonId,r as getPosthogAuthenticatedId,e as track};